console.log('_events.js ...');

function buttons(){


  $(document).on('click', 'body.front .abutton.home', function(event) { console.log('body.front .abutton.home <- don click')
    event.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 250);
    $('.akviewswiper0 .swiper-container')[0].swiper.slideTo(0);
  });

  $(document).on('click', 'body.front .abutton.reframe-bottom', function(event) { console.log('.swiper-button-up <- don click')
    event.preventDefault();
    $('html, body').animate({ scrollTop: $(".node-main-section .field-name-field-navfields").offset().top }, 250);
  });

  $(document).on('click', 'body.front .field-name-field-navfields a', function(event) { console.log('.field-name-field-navfields a <- don click')
    event.preventDefault();
    $('html, body').animate({ scrollTop: $(".ajax").offset().top }, 250);
  });

  $(document).on('click', 'body.front .abutton.profil', function(event) { console.log('body.front .abutton.profil <- don click')
    event.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 250);
    //$('.akviewswiper0 .swiper-container')[0].swiper.slideTo(2);
    $('.akviewswiper0 .swiper-container')[0].swiper.slideTo(2);
  });

  $(document).on('click', 'body.front .abutton.reframe', function(event) { console.log('body.front .abutton.reframe <- don click')
    event.preventDefault();
    $('.akjplayerV .jp-container').jPlayer('pause');
    $('html, body').animate({ scrollTop: $(".node-main-section").offset().top }, 250);
  });

  $(document).on('click', 'body.front .abutton.contact', function(event) { console.log('body.front .abutton.contact <- don click')
    event.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 250);
    $('.akviewswiper0 .swiper-container')[0].swiper.slideTo( $('.akviewswiper0 .swiper-slide').length-1);
  });

  $(document).on('click', 'body.front .abutton.partner', function(event) { console.log('body.front .abutton.partner <- don click')
    event.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 250);
    $('.akviewswiper0 .swiper-container')[0].swiper.slideTo(4);
  });


  $(document).on('click', 'body.front .abutton.vortraege', function(event) { console.log('body.front .abutton.vortraege <- don click')
    event.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 250);

    $('.akviewswiper0 .swiper-container')[0].swiper.slideTo( $('.akviewswiper0 .swiper-slide').length-2);
  });

  if( !$('.view-swiper').find('#node-24').length ) $('.abutton.vortraege').closest('li').remove();




  $(document).on('click', '.swiper-button-next', function(event) { console.log('.swiper-button-next <- don click')
    event.preventDefault();
    var swiper = $(this).closest('.swiper-container').get(0).swiper
    setTimeout(function () {
      swiper.slideTo(swiper.activeIndex+1);
    }, 10);


  });

  $(document).on('click', '.swiper-button-prev', function(event) { console.log('.swiper-button-prev <- don click')
    event.preventDefault();
    var swiper = $(this).closest('.swiper-container').get(0).swiper
    setTimeout(function () {
      swiper.slideTo(swiper.activeIndex-1);
    }, 10);
  });


  $(document).on('click', '#node-15 .close a', function(event) { console.log('.swiper-button-prev <- don click')
    event.preventDefault();
    $(this).closest('.item').hide();
  });

  $(document).on('click', '#node-15 .more', function(event) { console.log('.swiper-button-prev <- don click')
    event.preventDefault();
    $(this).closest('.item').next('.item').show();
  });


}
